import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import '@/styles/global.less';
import 'element-ui/lib/theme-chalk/index.css';

import "@/components/elementComponents";

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
